export const MOVE_FORWARD_BUTTON_TEST_ID = 'move-forward-button'
export const MOVE_BACKWARD_BUTTON_TEST_ID = 'move-backward-button'
export const RESET_BUTTON_TEST_ID = 'reset-button'
